export default __webpack_public_path__ + "static/media/R1.e59d2580.png";